import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

export const BADGE_COLORS = [
  'red',
  'orange',
  'yellow',
  'green',
  'blue',
  'darkblue',
  'indigo',
  'grey',
] as const;
export type SBadgeColor = (typeof BADGE_COLORS)[number];

export interface SBadgeProps extends HTMLAttributes<HTMLSpanElement> {
  /** 뱃지 색상 */
  color?: SBadgeColor;
}

/**
 * SBadge — sd-badge 포팅. 색상 점(dot) 인디케이터.
 * 색상은 컴포넌트 토큰 `--cmp-badge-<color>` 를 참조한다.
 */
export const SBadge = forwardRef<HTMLSpanElement, SBadgeProps>(function SBadge(
  { color = 'blue', className, ...rest },
  ref,
) {
  return (
    <span ref={ref} className={cn('inline-flex items-center justify-center', className)} {...rest}>
      <span
        className="rounded-full"
        style={{
          width: 'var(--cmp-badge-size, 6px)',
          height: 'var(--cmp-badge-size, 6px)',
          background: `var(--cmp-badge-${color})`,
        }}
      />
    </span>
  );
});
